import { render } from "./HowToWin.vue?vue&type=template&id=848d7660&scoped=true"
import script from "./HowToWin.vue?vue&type=script&lang=js"
export * from "./HowToWin.vue?vue&type=script&lang=js"

import "./HowToWin.vue?vue&type=style&index=0&id=848d7660&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-848d7660"]])

export default __exports__